<template>
<div class>
  <div class="row no-margin">
    <div class="col-12 iftable no-rp wrappertable">
      <portal target-el="#filter">
        <Header/>
      </portal>
      <div class="new">
        <div class="table" v-if="!isLoading">
          <Table :data="indentPayments" style="width: 100%" :max-height="windowHeight" aria-describedby="invoicePaymentsData">
            <Table-Column fixed="left" label="INDENT NO" width="150">
              <template slot-scope="indent">
                  <Popover trigger="click" placement="bottom" popper-class="newpopover leftalign">
                     <div class="popover-primary">
                      <div class="popover-primary-header">
                        <h3>INDENT DETAILS</h3>
                        <div class="popup_panel">
                          <div class="panel">
                          <div class="panel-grid">
                            <ul class="panel-grid-list">
                            <li v-for="(timeLine, key) in timeLines" :key="key">
                              <div class="panel-grid-list-header">
                                {{label[timeLine.label]}}
                              </div>
                              <div class="dropdown-section">
                                <div class="text-value">
                                  {{timeLine.time | moment("hh:mm A | DD MMM YYYY")}}
                                </div>
                              </div>
                            </li>
                            </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="popover-primary-body">
                        <IndentDetails :indentDetails="indentDetails" />
                      </div>
                    </div>
                     <div slot="reference" class="name-wrapper"
                      @click="showIndentDetails(indent.row.order_id)">
                      <div class="temp-style">
                        {{ indent.row.order_number }}
                      </div>
                    </div>
                  </Popover>
                </template>
            </Table-Column>
            <Table-Column v-for="column in getColumns" :key="column.id" width="100"
              prop="column.column" :label="`${column.label}`">
              <template slot-scope="payment">
                  <div class="table-td">
                    <div class="popup-block">
                   <Amount
                      :column="column.column"
                      :columnReadOnly="column.readonly"
                      :subStatus="column.sub"
                      :key="column.id"
                      @change="change"
                      :invoiceStatus="invoiceStatus"
                      :currentClientConfig="currentClientConfig"
                      :payment="payment.row"
                      :isReadOnly="column.readonly || readonly"
                      @addConversation='addConversation'/>

                    <Comments
                       v-if="column.comments"
                       :orderId="payment.row.order_id"
                       :commentLoading="commentLoading"
                       :comments="comments"
                       @getComments="getComments" />
                    </div>
                  </div>
                </template>
            </Table-Column>
            <Table-Column label="Documents" width="150">
              <template slot-scope="document">
                 <Popover trigger="click" placement="bottom" popper-class="newpopover">
              <div class="popover-primary">
                <div class="popover-primary-header">
                  <h3>ATTACHMENT</h3>
                  <!-- <span class="remove-icon" >
                    <svgicon name="cancelblack" width="12" height="12" :original="true" />
                  </span> -->
                </div>
                <div class="popover-primary-body">
                  <div class="uploadsection">
                  <Upload
                    v-if="!attachFile"
                    class="upload-demo"
                    ref="file"
                    :auto-upload="false"
                    action=""
                    :on-change="handleChange"
                    drag>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">Upload documents</div>
                    <div class="el-upload__tip" slot="tip">File with a size less than 5MB</div>
                  </Upload>

                  <div class="actionbtn" v-if="attachFile">
                    Filename:  {{attachFile.name}} <br/> <br/>
                  <button class="btn btn-secondary" @click="attachFile = null">Cancel</button>
                  <button class="btn btn-primary"
                    @click="handleFileUpload(document.row.id, document.$index)">Upload</button>
                </div>
              </div>
                  <div class="docsection" v-if="document.row.attachments.length">
                  <div class="popover-primary-header">
                  <h3 class="uploadtext">DOCUMENT</h3>
                  </div>

                  <div class="docsection-scroll">
                  <div class="docsection-list" v-for="attach in document.row.attachments"
                    :key="attach._id">
                    <div class="docsection-textfile">
                      <svgicon name="imggallery" width="30" height="30" :original="true" />
                    {{attach.name}}
                  </div>
                    <div class="docsection-action">
                    <a :href="attach.attachment_url" target="_blanks">
                      <svgicon name="download" width="12" height="12" :original="true" />
                      Download
                    </a>
                    </div>
                  </div>
                </div>

                </div>
                </div>
              </div>

              <div slot="reference" class="uploadtext">
                <div :class="[document.row.attachments.length ? 'success-style' : 'temp-style']">
                  {{ document.row.attachments.length ? 'Attachment' : 'Upload' }}
                </div>
              </div>
            </Popover>
                </template>
            </Table-Column>
            <Table-Column fixed="right" label="Total" width="150">
              <template slot-scope="invoice">
                  <div class="temp-style">
                    <Amount
                      column="total_amount"
                      :currentClientConfig="currentClientConfig"
                      :invoiceStatus="invoiceStatus"
                      :payment="invoice.row"
                      :isReadOnly="readonlyprop"
                    />
                  </div>
                </template>
            </Table-Column>
          </Table>
        </div>
      </div>

      <Footer v-if="!isLoading" :totalIntends="totalIntends" :getTotal="indentPayments" />
    </div>
    <!-- <div class="col-2 no-padding wrappertablegrey">
   <Comments />
      </div>-->
  </div>
</div>
</template>
<script>
import {
  mapGetters,
  mapState,
} from 'vuex';
import columns from '@/constants/payment-columns';
import Header from './header';
import Footer from './footer';
import Amount from '../common/amount';
import IndentDetails from '../common/IndentDetails';
import Comments from '../common/Comments';

export default {
  components: {
    Header,
    Amount,
    Footer,
    Comments,
    IndentDetails,
  },
  data() {
    return {
      value: null,
      readonlyprop: true,
      isLoading: false,
      commentpop: false,
      showAttachment: false,
      attachFile: null,
      indentDetails: {},
      label: {
        reportedAt: 'Reported At',
        firstTruckIn: 'Truck - In',
        lastTruckOut: 'Truck - Out',
      },
      columns: columns.map(column =>
        Object.assign({}, column, {
          w: `table-td-lite ${column.w}`, // this.checkColumn(column.column, 'contract_price')
          readonly: column.readonly,
        }),
      ),
    };
  },
  async created() {
    if (this.$store.showInvoice) {
      this.isLoading = true;
      try {
        const result = await this.$store.dispatch('payment/showinvoice', {
          id: this.$store.invoiceId,
        });
        this.$store.invoice = result;
        this.$store.payments = {
          selected: result.payments,
        };
      } catch (err) {
        this.$error({
          message: 'Unable to fetch invoice',
        });
      }
      this.isLoading = false;
    } else {
      this.isLoading = true;
      try {
        const paymentIds = this.$store.payments.selected.map(value => value.id);
        const result = await this.$store.dispatch('payment/getIndentDetails', {
          ids: paymentIds,
        });
        this.$store.payments = {
          selected: result,
        };
      } catch (err) {
        this.$error({ message: 'Unable to fetch Indent details' });
      }
      this.isLoading = false;
    }
  },
  computed: {
    ...mapState('payment', [
      'commentLoading',
      'comments',
    ]),
    ...mapGetters({
      currentClient: 'app/currentClient',
      currentClientConfig: 'app/currentClientConfig',
      isUploading: 'profile/isUploading',
    }),
    windowHeight() {
      return `${window.innerHeight - 250}px`;
    },
    indentPayments() {
      return this.$store.payments.selected.map(value =>
        value.charges.map(child => Object.assign({
          id: value.id,
          filter_type: value.filter_type,
          order_id: value.order.order_id,
          order_number: value.order.order_number,
          attachments: value.attachments,
          invoice_number: value.invoice_number,
        }, child)),
      ).reduce((l, n) => l.concat(n), []);
    },
    getColumns() {
      const getHeaders = [...this.columns];
      if (this.$hasFeature('detention_combine_days')) {
        getHeaders.splice(5, true); // Removed  unloading detention
        getHeaders[4].label = 'Detention'; // Rename loading detention as Detention
      }
      return getHeaders;
    },
    invoiceStatus() {
      return this.$store.invoice && this.$store.invoice.status ?
        this.$store.invoice.status :
        0;
    },
    totalIntends() {
      return this.$store.payments && this.$store.payments.selected ?
        this.$store.payments.selected.length :
        0;
    },
    calculateTotal() {
      const total = {
        transporter: 0,
        client: 0,
      };
      this.indentPayments.forEach((val, index) => {
        const selected = val.total_amount;
        if (selected) {
          total.transporter += Number(selected.transporter);
          total.client += Number(selected.client);
        }
      });
      return total;
    },
    readonly() {
      if (this.$hasFeature('edit_invoice_post_invoice') && this.$store.invoice
        && this.$store.invoice.status === 4) { return false; }
      return this.$store.showInvoice;
    },
    timeLines() {
      const times = [];
      const { timestamps } = this.indentDetails;
      if (timestamps) {
        if (this.$hasFeature('reported_at_depot') && timestamps.reported_at) {
          times.push({ label: 'reportedAt', time: timestamps.reported_at });
        }
        times.push({ label: 'firstTruckIn', time: timestamps.arrived_at });
        times.push({ label: 'lastTruckOut', time: timestamps.dispatched_at });
      }
      return times;
    },
  },
  methods: {
    showIndentDetails(orderId) {
      this.indentDetails = this.$store.payments.selected.find(indent =>
        indent.order.order_id === orderId);
    },
    handleChange(file, fileList) {
      this.attachFile = file.raw;
      this.fileList = [];
    },
    async handleFileUpload(paymentId, index) {
      try {
        this.file = this.attachFile;
        if (this.file.size > 1024 * 1024 * 5) {
          event.preventDefault();
          this.$error({
            message: 'File size too big > 5MB',
          });
          return;
        }
        const formData = new FormData();
        formData.append('attachment', this.file);
        const result = await this.$store.dispatch(
          'payment/uploadDocument',
          formData,
        );
        if (result.id) {
          this.attachFile = null;
          this.$success({
            message: 'Documents added successfully',
          });
          this.indentPayments[index].attachments.push({
            _id: result.id,
            name: result.name,
            attachment_url: result.attachment_url,
          });
          const data = {
            paymentId,
            attachment_id: result.id,
          };
          const response = await this.$store.dispatch('payment/addAttachment', {
            data,
          });
          if (response.error) {
            this.$error({
              message: response.error,
            });
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addConversation(value) {
      try {
        const data = {
          comment: value.comment,
          id: value.orderId,
          client_id: this.currentClient.id,
          type: 1,
          section: 1,
        };
        const result = await this.$store.dispatch('payment/addComment', {
          data,
        });
        if (result.error) {
          this.$error({
            message: result.error,
          });
        }
        if (result.length) {
          this.$success({
            message: 'Comments addded',
          });
        }
      } catch (e) {
      //  console.log(e);
      }
    },
    async getComments(paymentId) {
      try {
        const result = await this.$store.dispatch('payment/comments', {
          data: {
            id: paymentId,
            client_id: this.currentClient.id,
            section: 1,
          },
        });
        if (result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (e) {
        // console.log(e.response);
      }
    },
    change() {
      const value = this.calculateTotal;
      // this.indentPayments = this.indentPayments;
      // isChange = true;
      // console.log(this.$store.payments);
      // total(this.payments[0]);'
      // const seg = 'transporter';
      // this.$store.payments.selected.forEach((val, index) => {
      //   total(val.charges);
      // });
      // this.$emit('change');
    },
  },
};
</script>

<style lang="scss">
$fontSemibold: 'OpenSans-Semibold';
$fontBold: 'OpenSans-Bold';

.uploadsection {
    .upload-demo {
        .el-upload {
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            &__tip {
                margin-left: 20px;
            }
            &-dragger {
                width: 320px;
                height: 60px;
                margin-left: auto;
                margin-right: auto;
                margin-top: 15px;
                .el-upload__text {
                    line-height: 57px;
                    color: #303030;
                    font-size: 1.2rem;
                    background: #FBFBFB;
                }
                .el-icon-upload {
                    display: none;
                    line-height: 1px;
                }
            }
        }
    }
    .actionbtn {
        text-align: right;
        padding: 20px 15px 10px 20px;
    }
}
.uploadtext {
    .success-style {
        padding: 0 20px;
        cursor: pointer;
        text-decoration: underline;
        color: #4B8E00;
        font-family:$fontSemibold;
        font-size: 1.2rem;
    }
    .temp-style {
        padding: 0 20px;
        cursor: pointer;
        text-decoration: underline;
        font-family:$fontSemibold;
    }
}
.docsection {
    padding: 20px 0 0;
    &-scroll {
        height: 150px;
        overflow: auto;
    }
    &-list {
        padding: 0 20px;
        display: flow-root;
        margin-bottom: 10px;
    }
    &-textfile {
        display: inline-block;
        float: left;
        .svg-icon {
            padding-right: 5px;
        }
    }
    &-action {
        float: right;
        display: inline-block;
        a {
            color: #376F99;
            font-family:$fontBold;
            text-decoration: none;
        }
    }
}
.comment-pop {
    float: right;
}
.popup-block {
    .primary-text {
        padding-left: 10px;
    }
    .comment-pop {
        position: absolute;
        right: 10px;
        top: 9px;
    }
}

.popup_panel {
    .panel {
        border-bottom: 1px solid transparent;
        margin-left: -10px;
        margin-bottom: -6px;
        border: 1px solid transparent;
        &-grid {
            border-bottom: 1px solid transparent;
            &-list {
                border-bottom: 1px solid transparent;
                .text-value {
                    border-bottom: 1px solid transparent;
                    margin: 2px 10px !important;
                }
                li{
                      height: 54px;
                      min-width: 150px;
                      border-right: 1px solid #ebeef5;

                &:last-child{
                      border-right: 1px solid transparent;
                }
              }
            }
        }
    }
}
</style>
